// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.user.LeasingUserWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AssociateUserWebApiResponseDto,
  GetLeasingUserPageWebApiResponseDto,
  VerifyUserInfoWebApiResponseDto,
} from '../..';

interface AssociateUserParams {
  ouid: string;
}
interface GetLeasingUserPageParams {
  leaseId: number;
}
interface VerifyUserInfoParams {
  verifyUserInfoToken: string;
}
interface VerifyUserInfoForOuidParams {
  ouid: string;
  verifyUserInfoToken: string;
}

export const LeasingUserWebApiHandler_associateUser_Path = '/api/web/v1/user/associateUser';

/**
 * associate user with encoded lease, role and index
 */
export const LeasingUserWebApiHandler_associateUser = (getParams: AssociateUserParams, client = getClient()) => {
  return httpFrontEndRequest<AssociateUserParams, never, AssociateUserWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserWebApiHandler_associateUser_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingUserWebApiHandler_getLeasingUserPage_Path = '/api/web/v1/user/getLeasingUserPage';

/**
 * get leasing user page
 */
export const LeasingUserWebApiHandler_getLeasingUserPage = (
  getParams: GetLeasingUserPageParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeasingUserPageParams, never, GetLeasingUserPageWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserWebApiHandler_getLeasingUserPage_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingUserWebApiHandler_verifyUserInfo_Path = '/api/web/v1/user/verifyUserInfo';

/**
 * make sure user token still belongs to same tenant
 */
export const LeasingUserWebApiHandler_verifyUserInfo = (getParams: VerifyUserInfoParams, client = getClient()) => {
  return httpFrontEndRequest<VerifyUserInfoParams, never, VerifyUserInfoWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserWebApiHandler_verifyUserInfo_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingUserWebApiHandler_verifyUserInfoForOuid_Path = '/api/web/v1/user/verifyUserInfoForOuid';

/**
 * make sure co-landlord's session is still valid
 */
export const LeasingUserWebApiHandler_verifyUserInfoForOuid = (
  getParams: VerifyUserInfoForOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<VerifyUserInfoForOuidParams, never, VerifyUserInfoWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserWebApiHandler_verifyUserInfoForOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
